import {Component} from "react";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';


class ConnectsTo extends Component {
  static propTypes = {
    connectables: PropTypes.array,
    config: PropTypes.object,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.handleConnectsToChange = this.handleConnectsToChange.bind(this);
  }

  handleConnectsToChange(event) {
    console.log(event.target.value, event.target.checked)
    let config = Object.assign({}, this.props.config);
    if(event.target.checked){
      config.connectsTo.push(event.target.value);
    } else {
      config.connectsTo = config.connectsTo.filter(connection => connection !== event.target.value);
    }
    this.props.setToolConfig(this.props.config.id, config);
  }

  render() {
    return (
        <div className={"connectsTo"}>
          <Form.Group>
            <Form.Label>Connects To</Form.Label>
          {this.props.connectables && this.props.connectables.map((connection, index) => (
              <Form.Check
                  key={index}
                  type="checkbox"
                  id={connection}
                  label={this.props.connectables[index]}
                  value={this.props.connectables[index]}
                  onChange={this.handleConnectsToChange}
                  checked={this.props.config.connectsTo.includes(this.props.connectables[index])}
              />
          ))}
            <Form.Check
                type="checkbox"
                id={"MainPanOut"}
                label={"MainPanOut"}
                value={"MainPanOut"}
                onChange={this.handleConnectsToChange}
                checked={this.props.config.connectsTo.includes("MainPanOut")}
            />
          </Form.Group>
        </div>
    );
  }
}

export default ConnectsTo;